import React, { useEffect } from "react";
import "./AboutUs.css";
import { Link, useNavigate } from "react-router-dom";
import Owner from "../../assets/Owner.png";
import { useAuthContext } from "../../hooks/useAuthContext";
import Image1 from "../../assets/About/Image1.png";
import Image2 from "../../assets/About/Image2.png";
import Image3 from "../../assets/About/Image3.png";
import Image4 from "../../assets/About/Image4.png";

export default function AboutUs() {
  const navi = useNavigate();
  const { user } = useAuthContext();
  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container">
      <h1 className="mb-4">About Membotic</h1>

      <div className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Side: Image */}
            <div className="col-md-6 text-center mb-4 mb-md-0">
              <img
                src={Image1}
                alt="Clubs and members using Membotic"
                className="img-fluid rounded"
              />
            </div>

            {/* Right Side: Text */}
            <div className="col-md-6">
              <h2>What Is Membotic?</h2>
              <p>
                Membotic is a platform that helps clubs manage members, take
                payments, and run sessions with ease.
              </p>
              <p>
                From bulk class to subscriptions, it simplifies bookings, tracks
                attendance, and grows your community — all in one place.
              </p>
              <p>
                Handle payments, promote your club, and stay connected — your
                club, your way.
              </p>

              <p>
                <strong>Simple to use. Built to grow.</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Side: Image */}
            <div className="col-md-6 text-center mb-4 mb-md-0">
              <img
                src={Image2}
                alt="Membotic empowering clubs and communities"
                className="img-fluid rounded"
              />
            </div>

            {/* Right Side: Text */}
            <div className="col-md-6">
              <h2>Our Mission</h2>
              <p>
                At Membotic, our mission is to empower clubs and community-led
                businesses by giving them the tools they need to grow, thrive,
                and connect with their members.
              </p>
              <p>
                We believe in removing the barriers that slow down passionate
                club owners — making it easier to manage bookings, take
                payments, and build lasting relationships with their
                communities.
              </p>
              <p>
                Whether you're just starting out or scaling your operation,
                Membotic is here to support your journey every step of the way.
              </p>
              <p>
                <strong>
                  We exist to help your club succeed — simply, powerfully, and
                  sustainably.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="py-5 bg-light">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Side: Image */}
            <div className="col-md-6 text-center mb-4 mb-md-0">
              <img
                src={Image3}
                alt="Features and tools offered by Membotic"
                className="img-fluid rounded"
              />
            </div>

            {/* Right Side: Text */}
            <div className="col-md-6">
              <h2>Business Use</h2>
              <p>
                Membotic helps clubs run smoothly with tools for bookings,
                payments, member management, class scheduling, and more.
              </p>
              <ul>
                <li>Simple booking for sessions and events</li>
                <li>
                  Offer flexible payment options like subscriptions, one-off
                  payments, and more
                </li>
                <li>Member profiles and attendance tracking</li>
                <li>Support for families and group bookings</li>
                <li>In-app messaging with members</li>
                <li>Reach new audiences</li>
              </ul>
              <p>
                <strong>Everything you need — all in one place.</strong> <br />
                <button
                  className="saveChanges-button mt-2"
                  onClick={() => navi("/clubownerinfo")}
                >
                  Find out more
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Side: Image */}
            <div className="col-md-6 text-center mb-4 mb-md-0">
              <img
                src={Image4}
                alt="Users finding and booking clubs on Membotic"
                className="img-fluid rounded"
              />
            </div>

            {/* Right Side: Text */}
            <div className="col-md-6">
              <h2>Want to Join a Club?</h2>
              <p>
                Membotic helps you find, book, and manage club sessions near you
                — all in one place.
              </p>
              <ul>
                <li>Discover clubs and classes that suit you</li>
                <li>Book instantly — no calls or forms</li>
                <li>Pay per session, subscribe, or buy class bundles</li>
                <li>Manage profiles for you and your family</li>
                <li>Get booking reminders and updates</li>
                <li>Chat directly with club owners</li>
                <li>Track all your activities easily</li>
              </ul>
              <p>
                <strong>Easy to use. Built around you.</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      {!user && (
        <div className="py-5 text-center bg-white">
          <div className="container">
            <h2 className="mb-4">Ready to Get Started?</h2>
            <p className="mb-4">
              Whether you're running a club or looking to join one, Membotic
              helps make managing and accessing activities easier than ever.
              <br />
              Sign up today and see how simple it can be.
            </p>
            <button
              onClick={() => navi("/Register")}
              className="saveChanges-button fs-5"
            >
              Start Now
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
